import { TableColumnsType, Tag, Tooltip } from "antd";
export interface DataTypeError {
  titleColorDDMS?: string,
  titleColor?: string,
  titleCategoryCar?: string
  stt?: number
  clCar?: string,
  codeCar?: string,
  nameCar?: string,
  brand?: string,
  codeCustomer?: string,
  date?: string,
  status?: string
  note?: string
  staff?: string
  source?: string
  system?: string
  typeCar?: string
}

export const columns: TableColumnsType<DataTypeError> = [
  {
    title: 'STT',
    dataIndex: 'stt',
    key: '2'
  },
  {
    title: 'Mã màu DDMS',
    dataIndex: 'titleColorDDMS',
    render: (text: any) => <div className='text-2-row'>{text}</div>,
    width: 320,
  },
  {
    title: 'Tên màu xe',
    dataIndex: 'titleColor',
    render: (text: any) => <div className='text-2-row'>{text}</div>,
    width: 320,
  },
  {
    title: 'Tên thương hiệu',
    dataIndex: 'titleCategoryCar',
    render: (text: any) => <div className='text-2-row'>{text}</div>,
    width: 171,
  },
] as any

export const columnsErrorCar: TableColumnsType<DataTypeError> = [
  // stt: stt++,
  //       titleColorDDMS: item.titleColorDDMS,
  //       titleColor: item.titleColor,
  //       titleCategoryCar: item.titleCategoryCar,
  //       clCar: item.titleTypeVehicle,
  //       codeCar: item.code,
  //       nameCar: item.titleCar,
  //       brand: item.titleCategoryCar,
  //       typeCar: item.titleCarLines,
  //       codeCustomer: item.codeCustomer,
  //       date: formatDateToDMY(item?.dateReception),
  //       status: item.typeSupport,
  //       note: item.note,
  //       staff: item.adminName,
  //       source: item.supportChanel,
  //       system: item.sourceCustomer,
  //       type: type
  {
    title: 'Loại xe',
    dataIndex: 'clCar',
    // sorter: {
    //   compare: (a, b) => a?.clCar?.length - b?.clCar?.length,
    //   multiple: 1,
    // },
    className: "w-135-px"
  },
  {
    title: 'Mã xe',
    dataIndex: 'codeCar',
    // sorter: {
    //   compare: (a, b) => a.codeCar.length - b.codeCar.length,
    //   multiple: 1,
    // },
    render: (codeCar: string) => <div className='td-card-code'>{codeCar}</div>,
  },
  {
    title: 'Tên xe',
    dataIndex: 'nameCar',
    // sorter: {
    //   compare: (a, b) => a.nameCar.length - b.nameCar.length,
    //   multiple: 1,
    // },
    render: (nameCar: string) => <div className='td-card-name'>{nameCar}</div>,
  },
  {
    title: 'Thương hiệu',
    render: (logo: DataTypeError) => <div className='d-flex align-center gap-3 w-full'>

      <p className='text-sm font-regular text-98A2B3'>{logo.brand}</p>
    </div>,
    className: "w-132-px ",
  },

  {
    title: 'Dòng xe',
    dataIndex: 'typeCar',
    // sorter: {
    //   compare: (a, b) => a.typeCar.length - b.typeCar.length,
    //   multiple: 1,
    // },
    className: "w-163-px"
  },

];
export const columnsTypeCar: TableColumnsType<DataTypeError> = [
  {
    title: 'STT',
    dataIndex: 'stt',
    align: "center",
    width: 60,
  },

  {
    title: 'Loại xe',
    dataIndex: 'clCar',
    render: (text) => <div className='text-2-row'>{text}</div>,
    width: 501,
  },


];
export const columnsBrand: TableColumnsType<DataTypeError> = [
  {
    title: 'STT',
    dataIndex: 'stt',
    // sorter: {
    //   compare: (a, b) => a.stt - b.stt,
    //   multiple: 1,
    // },
    className: "w-60-px",
    align: "center",

  },
  {
    title: 'Tên thương hiệu',
    dataIndex: 'titleCategoryCar',
    render: (nameBrand: string) => <div className='text-2-row'>{nameBrand}</div>,
    className: "w-501-px"
  },

];
export const columnsCarLine: TableColumnsType<DataTypeError> = [

  {
    title: 'STT',
    dataIndex: 'stt',
    // sorter: {
    //   compare: (a, b) => a.stt - b.stt,
    //   multiple: 1,
    // },
    className: "w-60-px",
    align: "center"

  },
  {
    title: 'Tên thương hiệu',
    dataIndex: 'titleCategoryCar',
    className: "w-501-px",
    render: (text) => <div className='text-2-row'>{text}</div>
  },

  {
    title: 'Dòng xe',
    dataIndex: 'typeCar',
    className: "w-501-px",
    render: (text) => <div className='text-2-row'>{text}</div>
  },

];

export const tableColumnsFeedBack: TableColumnsType<DataTypeError> = [
  { title: 'STT', dataIndex: 'stt', key: 'stt', align: 'center', },
  {
    title: 'Mã khách hàng', dataIndex: 'codeCustomer', key: 'codeCustomer',
  },
  { title: 'Ngày chăm sóc', dataIndex: 'date', key: 'date', sorter: true, },
  {
    title: 'Hệ thống', dataIndex: 'system', key: 'system',
    render: (text: string) => <Tag className='rs-tag geek-blue'>{text}</Tag>
  },
  {
    title: 'Trạng thái', dataIndex: 'status', key: 'status',
    // render: (text: string, record: DataTypeError) => <Tag color={record.status.color} className='rs-tag'>{record.status.title}</Tag>
  },
  {
    title: 'Ghi chú', dataIndex: 'note', key: 'note',
    render: (text: string, record: DataTypeError) => (
      <Tooltip placement="top" title={text} >
        <div className="content-note-2">{text}</div>
      </Tooltip>
    ),
  },
  // { title: 'Đơn vị', dataIndex: 'unit', key: 'unit', },
  { title: 'Nguồn', dataIndex: 'source', key: 'source', },
  {
    title: 'Nhân viên xử lý', dataIndex: 'staff', key: 'staff',
    // render: (text: string, recod: DataTypeError) => <span className='primary-6'>{recod.staff.username}({recod.staff.code})</span>
  },
] as any
